export default __webpack_public_path__ + "static/media/Placement2.29a1b76f.jpg";